import React from 'react';
import {
	useCreateUnlayerEmailTemplateMutation,
	useDeleteUnlayerEmailTemplateMutation,
	useLazyGetUnlayerEmailTemplateDetailQuery,
	useLazyGetUnlayerEmailTemplateSummariesQuery,
	useUpdateUnlayerEmailTemplateMutation,
} from '@/features/unlayerEmailTemplates/unlayerEmailTemplatesApi';
import { UNLAYER_EMAIL_TEMPLATE_LABELS } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/labels';
import { UnlayerTemplatesEditorView } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView';
import { UnlayerTemplatesEditorProvider } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';

/**
 * Tab entry point for broker-authored Unlayer email templates. Wires the shared editor
 * hook to the standard email-template RTK Query endpoints.
 */
export const UnlayerEmailTemplatesTab = () => {
	return (
		<UnlayerTemplatesEditorProvider
			options={{
				labels: UNLAYER_EMAIL_TEMPLATE_LABELS,
				useLazyGetSummariesQuery: useLazyGetUnlayerEmailTemplateSummariesQuery,
				useLazyGetDetailQuery: useLazyGetUnlayerEmailTemplateDetailQuery,
				useCreateMutation: useCreateUnlayerEmailTemplateMutation,
				useUpdateMutation: useUpdateUnlayerEmailTemplateMutation,
				useDeleteMutation: useDeleteUnlayerEmailTemplateMutation,
			}}
		>
			<UnlayerTemplatesEditorView redirectWhenDisabled={true} />
		</UnlayerTemplatesEditorProvider>
	);
};
